import { useFormContext } from 'react-hook-form';

import { BidBuyFormType } from './useBidBuyForm';

export const useBidExceedsBuyPrice = (
  buyPrice: number | undefined,
  supportsBidding: boolean,
  supportsBuying: boolean,
): boolean => {
  const { watch } = useFormContext<BidBuyFormType>();

  const bid1 = watch('bid.bid1');
  const bid2 = watch('bid.bid2');
  const bid3 = watch('bid.bid3');

  if (!supportsBidding || !supportsBuying || !buyPrice) return false;

  const highestBid = Math.max(bid1?.amount ?? 0, bid2?.amount ?? 0, bid3?.amount ?? 0);
  return highestBid >= buyPrice;
};
